import {
  Component,
  inject,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Permission } from 'src/app/shared/constants/permissions';
import { CreateTicketComponent } from 'src/app/tickets/containers';

@Component({
  selector: 'app-help-cta',
  templateUrl: './help-cta.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HelpCtaComponent {
  @Input() originPage: string;

  @Input() hasInvoice = false;

  Permission = Permission;

  private dialog = inject(MatDialog);

  onCreateTicket(): void {
    this.dialog.open(CreateTicketComponent, {
      autoFocus: true,
      minHeight: '200px',
      maxHeight: 'calc(100vh - 20px)',
      width: '560px',
      maxWidth: 'calc(100vw - 20px)',
      data: { originPage: this.originPage },
      disableClose: true,
    });
  }
}
